var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "template6wrapper ti-fs-20 ti-font-regular pt-70 pt-md-200",
    },
    [
      _vm.question.title
        ? _c(
            "h1",
            {
              staticClass: "question-title ti-fs-28 ti-fs-md-56",
              attrs: { id: "radio-group-label" },
            },
            [_vm._v(_vm._s(_vm.question.title))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.question.subTitle
        ? _c("h2", [_vm._v(_vm._s(_vm.question.subTitle))])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(this.answers, function (answer) {
        return _c(
          "div",
          {
            key: answer.id,
            staticClass: "answerText",
            class: [
              answer.selected ? "selected" : "",
              answer.disabled ? "disabled" : "",
            ],
          },
          [
            _c("div", { staticClass: "answer_title" }, [
              _vm._v("\n            " + _vm._s(answer.title) + "\n        "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "answer_subtitle" }, [
              _vm._v("\n            " + _vm._s(answer.subTitle) + "\n        "),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "answersWrapper",
          style: _vm.answerStyle,
          attrs: { role: "radiogroup", "aria-labelledby": "radio-group-label" },
        },
        _vm._l(this.answers, function (answer) {
          return _c(
            "li",
            {
              key: answer.id,
              staticClass: "answerItem",
              class: [
                answer.selected && answer.isDefaultAnswer ? "selected" : "",
                answer.selected && !answer.isDefaultAnswer ? "selected" : "",
                answer.disabled ? "disabled" : "",
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "answer__left",
                  on: {
                    click: function ($event) {
                      return _vm.selectAnswer(answer.id)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "answer-icons" }, [
                    _c(
                      "button",
                      {
                        staticClass: "answer-button",
                        attrs: {
                          "data-cbt": _vm.getDataCbtValue(answer.text),
                          role: "radio",
                          "aria-checked": answer.selected ? "true" : "false",
                          "aria-label": answer.selected
                            ? _vm.selectedButtonText + " " + answer.text
                            : _vm.buttonText + " " + answer.text,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectAnswer(answer.id)
                          },
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "answer__circle ti-bg-color-silver",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !answer.disabled,
                          expression: "!answer.disabled",
                        },
                      ],
                      staticClass: "selector",
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "answer-titles" }, [
                    _c("div", { staticClass: "answer__title" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(answer.title) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "answer__subtitle" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(answer.subTitle) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "answer__line" }),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "ti-btn ti-btn-third mt-16 w-auto px-50 position-relative",
          attrs: { "data-cbt": _vm.getDataCbtValue(_vm.buttonText) },
          on: {
            click: function ($event) {
              return _vm.submitQuestion()
            },
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n    ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }